(function() {
	'use strict';

	angular.module('smb-app')
		.constant('smbIndexTypesDataTypes', {
			STRING: 0,
			NUMERIC: 1,
			DATE: 2,
			0: 'Text',
			1: 'Number',
			2: 'Date',
			STRING_MAX_LENGTH: 256
		});
}());


//////////////////
// WEBPACK FOOTER
// ./app/services/indexTypesDataTypes.js
// module id = 155
// module chunks = 1